import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';

interface PersonalInformationH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    thread?: ThreadAction;
}
@inject('app', 'site', 'user', 'thread')
@observer
class PersonalInformationH5Page extends BasePage<PersonalInformationH5PageProps> {
    componentDidMount() {
        const { app, user, site } = this.props;
        if(site) {
            site.setShowHeader(false);
            site.setAppDownloadShowStatus(false);
        }
        
        super.componentDidMount();
    }

    // 立即下载
    downloadClick = (id: string | number) => {
        // this.props.history && this.props.history.push(`/topic/${id}`);
    };


    render() {
        return (<div className={styles.wrapper}>
            <div className={styles.box}>

            <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>信息分类</th>
                            <th>信息名称</th>
                            <th>使用目的</th>
                            <th>使用场景</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowSpan={9}>用户基本信息</td>
                            <td>姓名</td>
                            <td>奖品发放、活动报名</td>
                            <td>用户在获得实物奖品填写邮寄信息时、用户在参与部分活动时</td>
                        </tr>
                        <tr>
                            <td>手机号</td>
                            <td>奖品发放、活动报名、账号登录、用户问题反馈</td>
                            <td>用户登录账号时、用户在获得实物奖品填写邮寄信息时、用户在参与部分活动时填写、用户在问题反馈中填写联系方式</td>
                        </tr>
                        <tr>
                            <td>住址</td>
                            <td>奖品发放、活动报名</td>
                            <td>用户在获得实物奖品填写邮寄信息时、用户参加部分线下活动时</td>
                        </tr>
                        <tr>
                            <td>性别</td>
                            <td>社区个人资料展示、活动报名</td>
                            <td>用户每次完善/更新个人资料时、用户参与部分活动时</td>
                        </tr>
                        <tr>
                            <td>年龄</td>
                            <td>社区个人资料展示、活动报名</td>
                            <td>用户每次完善/更新个人资料时、用户参与部分活动时</td>
                        </tr>
                        <tr>
                            <td>身份证号</td>
                            <td>活动报名时</td>
                            <td>用户参与部分活动时</td>
                        </tr>
                        <tr>
                            <td>职业</td>
                            <td>活动报名时</td>
                            <td>用户参与部分活动时</td>
                        </tr>
                        <tr>
                            <td>所在地区</td>
                            <td>活动报名时</td>
                            <td>用户参与部分活动时</td>
                        </tr>
                        <tr>
                            <td>出生日期</td>
                            <td>社区个人资料展示、活动报名</td>
                            <td>用户每次完善/更新个人资料时、用户参与部分活动时</td>
                        </tr>
                        <tr>
                            <td rowSpan={9}>用户网络身份识别和鉴权信息</td>
                            <td>头像</td>
                            <td>个人信息展示， 用户发布内容</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>账号</td>
                            <td>个人信息展示</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>昵称</td>
                            <td>个人信息展示 用户发布内容</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>手机号</td>
                            <td>个人身份识别</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>openID</td>
                            <td>个人身份识别</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>aaid</td>
                            <td>个人身份识别</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>guid、</td>
                            <td>个人身份识别</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>meid</td>
                            <td>个人身份识别</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td>udid</td>
                            <td>个人身份识别</td>
                            <td>用户每次登录账号时</td>
                        </tr>
                        <tr>
                            <td rowSpan={2}>用户使用信息</td>
                            <td>照片</td>
                            <td>发帖评论、与其他用户私信交流、更换背景图、头像</td>
                            <td>用户在社区发帖或评论时、用户私信交流发送图片时、用户更换主页背景图时、用户更换头像图片时，用户提交报名表单时</td>
                        </tr>
                        <tr>
                            <td>视频</td>
                            <td>发帖评论、与其他用户私信交流</td>
                            <td>用户在社区发帖或评论时、用户私信交流发送图片时</td>
                        </tr>

                        <tr>
                            <td rowSpan={2}>位置信息</td>
                            <td>IP地址、网络模糊定位信息</td>
                            <td>按网信办要求展示用户位置信息，判断用户能否参加线下打卡活动</td>
                            <td>用户在社区发帖或评论时、用户每次使用“附近门店”功能时</td>
                        </tr>
                        <tr>
                            <td>GPS定位信息</td>
                            <td>判断用户能否参加线下打卡活动</td>
                            <td>用户参加线下打卡活动时</td>
                        </tr>


                        <tr>
                            <td rowSpan={5}>交流信息</td>
                            <td>社区私信内容</td>
                            <td>用户私信对话</td>
                            <td>用户每次私信对话时</td>
                        </tr>
                        <tr>
                            <td>社区发帖内容</td>
                            <td>社区中展示帖子内容</td>
                            <td>用户每次发帖、保存草稿时</td>
                        </tr>
                        <tr>
                            <td>社区帖子评论内容</td>
                            <td>社区中展示帖子评论内容</td>
                            <td>用户每次发表评论时</td>
                        </tr>
                        <tr>
                            <td>社区内容举报</td>
                            <td>管理平台展示举报内容</td>
                            <td>用户举报内容时</td>
                        </tr>
                        <tr>
                            <td>社区用户发布反馈内容</td>
                            <td>社区中展示反馈内容</td>
                            <td>用户发表反馈时</td>
                        </tr>

                        <tr>
                            <td>用户违规记录</td>
                            <td>发布违规信息记录</td>
                            <td>相关政策法规要求</td>
                            <td>用户发表违规言论时</td>
                        </tr>
                        
                        <tr>
                            <td rowSpan={4}>服务日志</td>
                            <td>cookie内容</td>
                            <td>提供基础信息流功能</td>
                            <td>用户每次打开软件时</td>
                        </tr>
                        <tr>
                            <td>搜索查询词条</td>
                            <td>提供搜索服务</td>
                            <td>用户输入搜索关键词时</td>
                        </tr>
                        <tr>
                            <td>软件运行日志</td>
                            <td>故障排查分析、漏洞修复</td>
                            <td>软件发生崩溃、卡顿、无响应等故障时</td>
                        </tr>
                        <tr>
                            <td>软件浏览记录</td>
                            <td>用户体验改善</td>
                            <td>用户浏览软件信息时</td>
                        </tr>

                        <tr>
                            <td rowSpan={5}>设备属性</td>
                            <td>硬件型号</td>
                            <td>用户问题反馈、升级尝鲜</td>
                            <td>用户在反馈问题填写时、用户申请升级尝鲜（内测、公测、升级尝鲜）时</td>
                        </tr>
                        <tr>
                            <td>系统版本号</td>
                            <td>用户问题反馈、升级尝鲜</td>
                            <td>用户在反馈问题填写时、用户申请升级尝鲜（内测、公测、升级尝鲜）时</td>
                        </tr>
                        <tr>
                            <td>传感器</td>
                            <td>视频播放时判断横屏竖屏</td>
                            <td>用户查看视频时</td>
                        </tr>
                        <tr>
                            <td>IMEI</td>
                            <td>用户问题反馈</td>
                            <td>用户在反馈问题填写时</td>
                        </tr>
                        <tr>
                            <td>VAID</td>
                            <td>用户体验改善、统计分析、安全风控</td>
                            <td>用户每次打开软件时</td>
                        </tr>

                    </tbody>
                </table>

                
            </div>
        </div>)
    }
}

export default withRouter(PersonalInformationH5Page);
